module.exports = __webpack_public_path__ + "img/banneri-per-ne.6f39d1be.jpeg";